import type { LocationsServiceFacade } from './LocationsServiceFacade';

/**
 * Module-level holder for the active LocationsServiceFacade.
 *
 * Redux thunks live outside the React tree and can't consume context, so the
 * Provider mounts the facade here on render and the thunks read it back when
 * dispatching. When the holder is empty (tests, before the Provider has
 * mounted) callers should fall back to direct API calls.
 */
let current: LocationsServiceFacade | null = null;

export function setLocationsServiceInstance(facade: LocationsServiceFacade | null): void {
  current = facade;
}

export function getLocationsServiceInstance(): LocationsServiceFacade | null {
  return current;
}
